import { viemChains } from '../constants'
import type { NetworkToIdMap } from '../types'

type ViemChainKey = keyof typeof viemChains

export function getChainId<T extends ViemChainKey | string>(network: T) {
  const chainId = viemChains[network as keyof typeof viemChains]?.id
  if (!chainId) {
    throw new Error(`Chain ${network} not found in config`)
  }
  return chainId as T extends ViemChainKey ? NetworkToIdMap[T] : number
}
